import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  Alert,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { sacolaService, Sacola } from '../../services/sacola';

const SacolaVisualizar: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const idSacola = Number(id);

  const [sacola, setSacola] = useState<Sacola | null>(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' as 'error' | 'success' });

  const { data: sacolaData, isLoading, error } = useQuery<Sacola>({
    queryKey: ['sacola', idSacola],
    queryFn: () => sacolaService.getById(idSacola),
    enabled: !!idSacola,
  });

  useEffect(() => {
    if (sacolaData) {
      setSacola(sacolaData);
    }
  }, [sacolaData]);

  const handleVoltar = () => {
    navigate('/Sacola');
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <Typography>Carregando...</Typography>
      </Box>
    );
  }

  if (error || !sacola) {
    const errorMessage = (error as any)?.response?.data?.title
      || (error as any)?.response?.data?.message
      || (error as any)?.message
      || 'Erro ao carregar a sacola.';
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4, flexDirection: 'column', alignItems: 'center' }}>
        <Typography color="error" gutterBottom>Erro ao carregar a sacola.</Typography>
        <Typography color="error" variant="body2">{errorMessage}</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h1">
          Sacola {idSacola}
        </Typography>
        <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={handleVoltar}>
          Voltar
        </Button>
      </Box>

      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2, mb: 3 }}>
        <TextField label="Funcionário que incluiu" value={sacola.nomeUsuario || ''} slotProps={{ input: { readOnly: true } }} />
        <TextField label="Data da inclusão" value={sacola.data || ''} slotProps={{ input: { readOnly: true } }} />
      </Box>

      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>Código de Barras</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(sacola.produtos || []).length === 0 ? (
                <TableRow>
                  <TableCell align="center">
                    <Typography color="text.secondary">Nenhum produto na sacola.</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                (sacola.produtos || []).map((produto, index) => (
                  <TableRow key={produto.idCodigoBarras || index}>
                    <TableCell>{produto.codigoBarras}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default SacolaVisualizar;
